<template>
    <!--
        Link: https://getdatepicker.com/4/
     -->
    <div>
        <div    class="relative overflow-visible w-full"
                :id="`${id}_container`"
                :ref="`${id}_container`">
            <input type="text"  :id="id"
                   :name="name"
                   :placeholder="placeholder"
                   class="w-full py-1 px-3 text-gray-800 leading-normal rounded text-base border rounded text-center"
            >
        </div>
    </div>

</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
    name: "DateTimePicker",
    mixins: [],
    components: {},
    emits: ['update:modelValue'],
    // Date Objects are preffered for these
    props: {
        modelValue: Date,
        format: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss',
        },
        minDate: {
            type: [Date, String],
            default: null,
        },
        maxDate: {
            type: [Date, String],
            default: null,
        },
        id: {
            type: String,
            default() {
                return 'datetimepicker_' + uuidv4()
            },
        },
        name: {
          type: String,
          default() {
            return 'datetimepicker'
          }
        },
        viewMode: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: '',
        },
        sideBySide: {
            // Side-by-side must be true if the format includes displaying time.
            type: Boolean,
            default: false,
        },
        verticalPosition: {
            type: String,
            default: 'auto',
        },
        horizontalPosition: {
            type: String,
            default: 'auto',
        },
        timezone: {
            type: String,
            default: null
        },
        defaultCurrentTime: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            options: {},
            date: this.modelValue,
            dateTimePicker: null,
            element: null,
            created: false,
        }
    },
    created() {
        this.resetOptions()
    },
    mounted() {
        this.createPicker()

        // This is to initialize the date (in case it's invalid.)
        if (this.created) {
            $(this.element).data("DateTimePicker").show()
            $(this.element).data("DateTimePicker").hide()
        }


    },
    beforeUnmount() {
        this.removePicker()
    },
    methods: {
        resetOptions() {
            this.options = {
                format: this.format,
                date: this.date,
                sideBySide: this.sideBySide,
                widgetPositioning: {
                    vertical: this.verticalPosition,
                    horizontal: this.horizontalPosition,
                },
                useCurrent: this.defaultCurrentTime,
            }
            if (this.viewMode) {
                this.options['viewMode'] = this.viewMode
            }
            if (this.minDate) {
                this.options['minDate'] = this.minDate
            }
            if (this.maxDate) {
                this.options['maxDate'] = this.maxDate
            }
            if (this.timezone) {
                this.options['timeZone'] = this.timezone
            }
        },
        createPicker() {
            try {
                this.element = $("#" + this.id)
                    .datetimepicker(this.options).on('dp.change', event => {
                            console.log(event.date)
                            this.$emit('update:modelValue', new Date(event.date.toString()))
                        }
                    ).datetimepicker()
                $(this.element).data("DateTimePicker").widgetParent(`#${this.$refs[this.id + '_container'].id}`)

                this.created = true
            }
            catch (e) {
                console.log(`Failed to create DateTimePicker.${this.id}`)
                console.log(e.message)
            }
        },
        removePicker() {
            if (this.created) {
                try {
                    $(this.element).data("DateTimePicker").destroy()
                    this.created = false
                }
                catch (e) {
                    console.log(`Failed to remove DateTimePicker.${this.id}`)
                    console.log(e.message)
                    console.debug(e)
                }
            }
        },
        isValidDate(date) {
            return date instanceof Date && !isNaN(date.valueOf())
        },
    },
    watch: {
        format(val) {
            $(this.element).data("DateTimePicker").format(val)
            $(this.element).data("DateTimePicker").date(this.modelValue)
        },
        viewMode(val) {
            $(this.element).data("DateTimePicker").viewMode(val)
            $(this.element).data("DateTimePicker").date(this.modelValue)
        },
        modelValue(val) {
            if (!this.isValidDate(val) || !this.created) {
                return
            }
            $(this.element).data("DateTimePicker").date(this.modelValue)
        },
        minDate(val) {
            if (!this.isValidDate(val)) {
                return
            }
            $(this.element).data("DateTimePicker").minDate(val)
        },
        maxDate(val) {
            if (!this.isValidDate(val)) {
                return
            }
            $(this.element).data("DateTimePicker").maxDate(val)
        },
        timezone(val) {
            $(this.element).data("DateTimePicker").timeZone(val)
            $(this.element).data("DateTimePicker").date(this.modelValue)
        },
    },
    computed: {

    },
}
</script>

<style scoped>

</style>